export default __webpack_public_path__ + "static/media/explore-portfolio.6b2604ff.svg";